import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Branch } from "../../types/user";

export interface LayoutState {
  isSideMenuOpen: boolean;
  isMobile: boolean;
  isTablet: boolean;
  currentBranch: Branch | null;
  availableBranches: Branch[];
}

const initialState: LayoutState = {
  isSideMenuOpen: false,
  isMobile: false,
  isTablet: false,
  currentBranch: null,
  availableBranches: [],
};

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    toggleSideMenu(state) {
      state.isSideMenuOpen = !state.isSideMenuOpen;
    },
    setSideMenuOpen(state, action: PayloadAction<boolean>) {
      state.isSideMenuOpen = action.payload;
    },
    setViewportMode(
      state,
      action: PayloadAction<{ isMobile: boolean; isTablet: boolean }>
    ) {
      state.isMobile = action.payload.isMobile;
      state.isTablet = action.payload.isTablet;
      if (!state.isMobile && !state.isTablet) {
        state.isSideMenuOpen = true;
      } else {
        state.isSideMenuOpen = false;
      }
    },
    setCurrentBranch(state, action: PayloadAction<Branch | null>) {
      state.currentBranch = action.payload;
    },
    setAvailableBranches(state, action: PayloadAction<Branch[]>) {
      state.availableBranches = action.payload;
    },
  },
});

export const {
  toggleSideMenu,
  setSideMenuOpen,
  setViewportMode,
  setCurrentBranch,
  setAvailableBranches,
} = layoutSlice.actions;

export default layoutSlice.reducer;

